// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"Textsearch_searchBox_1SbLb"};